const state = {
  selectedLog: null,
  selectedLogDetails: null,
  isLoadingLogDetails: false,
};

const mutations = {
  SET_SELECTED_LOG: (state, log) => {
    state.selectedLog = log;
  },
  SET_SELECTED_LOG_DETAILS: (state, details) => {
    state.selectedLogDetails = details;
  },
  SET_IS_LOADING_LOG_DETAILS: (state, loading) => {
    state.isLoadingLogDetails = loading;
  },
};

const actions = {
  updateSelectedLog({ commit }, log) {
    commit("SET_SELECTED_LOG", log);
  },
  updateSelectedLogDetails({ commit }, details) {
    commit("SET_SELECTED_LOG_DETAILS", details);
  },
  updateIsLoadingLogDetails({ commit }, loading) {
    commit("SET_IS_LOADING_LOG_DETAILS", loading);
  },
  resetData({ commit }) {
    commit("SET_SELECTED_LOG", null);
    commit("SET_SELECTED_LOG_DETAILS", null);
  },
};

const getters = {
  getSelectedLog: (state) => state.selectedLog,
  getSelectedLogDetails: (state) => state.selectedLogDetails,
  getIsLoadingLogDetails: (state) => state.isLoadingLogDetails,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
